import React, { useRef, useState, useEffect } from "react";
import {
    I2cRadioGroup, I2cRadioButton, I2cButton, I2cIcon
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../PrepaidComponents/Prepaid.scss";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { Controller } from "react-hook-form";
import { InputRenderer, CheckboxTableRenderer, HeaderCheckboxRenderer, EnrollmentFieldRenderer } from "./CellRenderer";
import { consumer_loginInfo, consumer_personalInfo, consumer_sourceOfIncomeInfo, consumer_documentary_proof, consumer_identification_details } from './stringUtils';
import { I2cDataTable } from '@webcomponents/i2cwebcomponents/dist/react';
import AppSelectionIcons from "../AppSelectionForProgram/AppSelectionIcons"

const ConsumerEnrollmentAndShippmentMethod = ({ type, control, handleValueChanges, methods, errors, appSelectionForProgram, isFormDataUpdated }) => {
    const [gridOptionsLoginInfo, setGridOptionsLoginInfo] = useState({});
    const [gridOptionsPersonalInfo, setGridOptionsPersonalInfo] = useState({});
    const [gridOptionsSourceOfIncome, setGridOptionsSourceOfIncome] = useState({});
    const [gridOptionsDocumentaryProof, setGridOptionsDocumentaryProofInfo] = useState({});
    const [gridOptionsIdentificationDetailsInfo, setGridOptionsIdentificationDetailsInfo] = useState({});
    const tableRefs = {
        consumer_login_info: useRef(null),
        consumer_personal_info: useRef(null),
        consumer_source_of_income_info: useRef(null),
        consumer_identification_details: useRef(null),
        consumer_documentary_proof: useRef(null),
    };
    const tables = [
        { id: 'consumer_login_info', dataKey: 'card_enrollment_fields_for_consumer_login_info', tableName: "Login Information", initialData: consumer_loginInfo, stateSetter: setGridOptionsLoginInfo },
        { id: 'consumer_personal_info', dataKey: 'card_enrollment_fields_for_consumer_personal_info', tableName: "Personal Information", initialData: consumer_personalInfo, stateSetter: setGridOptionsPersonalInfo },
        { id: 'consumer_source_of_income_info', dataKey: 'card_enrollment_fields_for_consumer_source_of_income_info', tableName: "Source of Income", initialData: consumer_sourceOfIncomeInfo, stateSetter: setGridOptionsSourceOfIncome },
    ];
    const tablesWithAddRecordButton = [
        { id: 'consumer_identification_details', dataKey: 'card_enrollment_fields_for_consumer_identification_info', tableName: "Identification Detail", initialData: consumer_identification_details, stateSetter: setGridOptionsIdentificationDetailsInfo },
        { id: 'consumer_documentary_proof', dataKey: 'card_enrollment_fields_for_consumer_documentary_proof_info', tableName: "Documentary Proof", initialData: consumer_documentary_proof, stateSetter: setGridOptionsDocumentaryProofInfo },
    ];
    const noData = [
        {
            description: 'No data available. Please add some features or refresh the page.',
            type: 'noData',
            icon: 'outline-info-circle',
            primaryBtn: `<i2c-button variant="primary" size='large'>Reload</i2c-button>`,
        },
    ]
    const addNewRow = (table) => {
        const newRow = {
            enrollment_field: 'Click to edit',
            enable: false,
            mandatory: false,
            disabled: false,
            deleteable: true,
        };
        const updatedData = [...methods.getValues(table.dataKey), newRow];
        methods.setValue(table.dataKey, updatedData);
        const api = tableRefs[table.id]?.current?.getGridApi();
        if (api) {
            api.applyTransaction({ add: [newRow] });
        } else {
            console.error("Grid API not found!");
        }
    };
    useEffect(() => {
        tablesWithAddRecordButton.forEach((table) => {
            const backendData = methods.getValues(table.dataKey);
            const gridOptions = (backendData?.length > 0 ?
                {
                    columnDefs: [
                        { headerName: 'Enrollment Field', field: 'enrollment_field', cellRenderer: EnrollmentFieldRenderer, editable: true },
                        { headerName: 'Enable', field: 'enable', cellRenderer: CheckboxTableRenderer, headerComponent: HeaderCheckboxRenderer },
                        { headerName: 'Mandatory', field: 'mandatory', cellRenderer: CheckboxTableRenderer, headerComponent: HeaderCheckboxRenderer }
                    ],
                    rowSelection: 'single',
                    rowData: backendData,
                    suppressMoveWhenRowDragging: true,
                    context: { methods, handleValueChanges, tableType: table.dataKey }
                }
                :
                {
                    columnDefs: [
                        { headerName: 'Enrollment Field', field: 'enrollment_field', editable: true },
                        { headerName: 'Enable', field: 'enable', cellRenderer: InputRenderer },
                        { headerName: 'Mandatory', field: 'mandatory', cellRenderer: InputRenderer }
                    ],
                    rowSelection: 'single',
                    rowData: table.initialData || [],
                    suppressMoveWhenRowDragging: true,
                    context: { methods, handleValueChanges, tableType: table.dataKey }
                }
            );
            table.stateSetter(gridOptions);
            const api = tableRefs[table.id]?.current?.getGridApi();
            if (api) {
                api.setRowData && api.setRowData(backendData?.length > 0 ? backendData : table.initialData || []);
            }
        });
    }, [isFormDataUpdated]);
    useEffect(() => {
        tables.forEach((table) => {
            const backendData = methods.getValues(table.dataKey);
            const gridOptions = (backendData?.length > 0 ?
                {
                    columnDefs: [
                        { headerName: 'Enrollment Field', field: 'enrollment_field' },
                        { headerName: 'Enable', field: 'enable', cellRenderer: CheckboxTableRenderer, headerComponent: HeaderCheckboxRenderer },
                        { headerName: 'Mandatory', field: 'mandatory', cellRenderer: CheckboxTableRenderer, headerComponent: HeaderCheckboxRenderer }
                    ],
                    rowSelection: 'single',
                    rowData: backendData,
                    suppressMoveWhenRowDragging: true,
                    context: { methods, handleValueChanges, tableType: table.dataKey }
                }
                :
                {
                    columnDefs: [
                        { headerName: 'Enrollment Field', field: 'enrollment_field', editable: true },
                        { headerName: 'Enable', field: 'enable', cellRenderer: InputRenderer },
                        { headerName: 'Mandatory', field: 'mandatory', cellRenderer: InputRenderer }
                    ],
                    rowSelection: 'single',
                    rowData: table.initialData || [],
                    suppressMoveWhenRowDragging: true,
                    context: { methods, handleValueChanges, tableType: table.dataKey }
                }
            );
            table.stateSetter(gridOptions);
            const api = tableRefs[table.id]?.current?.getGridApi();
            if (api) {
                api.setRowData && api.setRowData(backendData?.length > 0 ? backendData : table.initialData || []);
            }
        });
    }, [isFormDataUpdated]);

    return (
        <>
            <div i2c-grid="grid gap-md">
                <div i2c-grid="12">
                    <div className="sub-heading">
                        <div className="sub-heading">
                            <span className="productIconFlex">
                                <span slot="label" className="organize-tooltip">
                                    {
                                        type === "credit" ? "Consumer Enrollment" : "Customer Onboarding"
                                    }
                                </span>
                                <AppSelectionIcons
                                    appSelectionForProgram={appSelectionForProgram}
                                    mobileLink="https://example.com/mobile-app-a"
                                    webLink="https://example.com/web-app-a"
                                />
                            </span>
                        </div>
                    </div>
                </div>
                <div i2c-grid="12">
                    <div className="single-field-wrapper">
                        <Controller
                            name="card_enrollment_create_user_during_enrollment"
                            control={control}
                            render={({ field }) => (
                                <I2cRadioGroup
                                    label="Please select if you want to create users during enrollment."
                                    {...field}
                                    name="card_enrollment_create_user_during_enrollment"
                                    onI2cChange={(e) => {
                                        field.onChange(e);
                                        methods.trigger();
                                        handleValueChanges();
                                    }}
                                >
                                    {["Yes", "No"].map((cECUDED, index) => (
                                        <I2cRadioButton
                                            key={index}
                                            checked={
                                                methods.watch("card_enrollment_create_user_during_enrollment") === cECUDED
                                            }
                                            value={cECUDED}
                                        >
                                            {cECUDED}
                                        </I2cRadioButton>
                                    ))}
                                </I2cRadioGroup>
                            )}
                        />
                        <ErrorMessage
                            show={
                                errors.card_enrollment_create_user_during_enrollment &&
                                    methods.formState.touchedFields.card_enrollment_create_user_during_enrollment
                                    ? true
                                    : false
                            }
                            message={errors.card_enrollment_create_user_during_enrollment?.message ?? "Invalid input"}
                        />
                    </div>
                </div>

                <div i2c-grid="12">
                    <div className="single-field-wrapper">
                        <Controller
                            name="card_enrollment_customer_email_as_user_id"
                            control={control}
                            render={({ field }) => (
                                <I2cRadioGroup
                                    label="Do you want to use the customer’s Email ID as the user ID?"
                                    {...field}
                                    name="card_enrollment_customer_email_as_user_id"
                                    onI2cChange={(e) => {
                                        field.onChange(e);
                                        methods.trigger();
                                        handleValueChanges();
                                    }}
                                >
                                    {["Yes", "No"].map((data, index) => (
                                        <I2cRadioButton
                                            key={index}
                                            checked={
                                                methods.watch("card_enrollment_customer_email_as_user_id") === data
                                            }
                                            value={data}
                                        >
                                            {data}
                                        </I2cRadioButton>
                                    ))}
                                </I2cRadioGroup>
                            )}
                        />
                        <ErrorMessage
                            show={
                                errors.card_enrollment_customer_email_as_user_id &&
                                    methods.formState.touchedFields.card_enrollment_customer_email_as_user_id
                                    ? true
                                    : false
                            }
                            message={errors.card_enrollment_customer_email_as_user_id?.message ?? "Invalid input"}
                        />
                    </div>
                </div>
                {
                    methods.watch("card_enrollment_customer_email_as_user_id") === "No" && (
                        <div i2c-grid="12">
                            <div className="single-field-wrapper">
                                <Controller
                                    name="card_enrollment_show_email_id_on_screen"
                                    control={control}
                                    render={({ field }) => (
                                        <I2cRadioGroup
                                            label="Do you want to show the Email ID field on the screen?"
                                            {...field}
                                            name="card_enrollment_show_email_id_on_screen"
                                            onI2cChange={(e) => {
                                                field.onChange(e);
                                                methods.trigger();
                                                handleValueChanges();
                                            }}
                                        >
                                            {["Yes", "No"].map((data, index) => (
                                                <I2cRadioButton
                                                    key={index}
                                                    checked={
                                                        methods.watch("card_enrollment_show_email_id_on_screen") === data
                                                    }
                                                    value={data}
                                                >
                                                    {data}
                                                </I2cRadioButton>
                                            ))}
                                        </I2cRadioGroup>
                                    )}
                                />
                                <ErrorMessage
                                    show={
                                        errors.card_enrollment_show_email_id_on_screen &&
                                            methods.formState.touchedFields.card_enrollment_show_email_id_on_screen
                                            ? true
                                            : false
                                    }
                                    message={errors.card_enrollment_show_email_id_on_screen?.message ?? "Invalid input"}
                                />
                            </div>
                        </div>
                    )
                }
                <div i2c-grid="12">
                    <div className="custom-label mb-8">
                        Please select enrollment fields for the program.
                    </div>
                    <div className="section-tables-containers">

                        {tables.map((table) => (
                            <div i2c-grid="grid gap-md" className="section-space">
                                <div i2c-grid="12" className="cholder-label-heading">
                                    {table.tableName}
                                </div>
                                <div i2c-grid="12">
                                    <Controller
                                        key={table.id}
                                        name={table.dataKey}
                                        control={control}
                                        render={({ field }) => (
                                            <I2cDataTable
                                                id={`dataTable_${table.id}`}
                                                ref={tableRefs[table.id]}
                                                gridOptionInput={
                                                    table.id === 'consumer_login_info' ? gridOptionsLoginInfo :
                                                        table.id === 'consumer_personal_info' ? gridOptionsPersonalInfo :
                                                            gridOptionsSourceOfIncome
                                                }
                                                notFound={noData}
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        ))}
                        {tablesWithAddRecordButton.map((table) => (
                            <div i2c-grid="grid gap-md" className="section-space">
                                <div i2c-grid="12" className="cholder-label-heading">
                                    {table.tableName}
                                </div>
                                <div i2c-grid="12">
                                    <Controller
                                        key={table.id}
                                        name={table.dataKey}
                                        control={control}
                                        render={({ field }) => (
                                            <I2cDataTable
                                                id={`dataTable_${table.id}`}
                                                ref={tableRefs[table.id]}
                                                gridOptionInput={
                                                    table.id === 'consumer_identification_details' ? gridOptionsIdentificationDetailsInfo :
                                                        gridOptionsDocumentaryProof
                                                }
                                                notFound={noData}
                                            />
                                        )}
                                    />
                                </div>
                                <div i2c-grid="12"> 
                                    <I2cButton variant="link color"
                                         onClick={() => addNewRow(table)}>
                                        <I2cIcon slot="prefix" name="linear-add"></I2cIcon> Add 
                                    </I2cButton>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ConsumerEnrollmentAndShippmentMethod;                  
